var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineStartCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 12,
    viewBox: "0 0 25 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00032 11.3332C3.05481 11.3332 0.666991 8.94536 0.666992 5.99984C0.666992 3.05432 3.05481 0.666504 6.00033 0.666504C8.60405 0.666505 10.772 2.53231 11.2401 4.99984L24.0003 4.99984C24.5526 4.99984 25.0003 5.44755 25.0003 5.99984C25.0003 6.55212 24.5526 6.99984 24.0003 6.99984L11.2401 6.99984C10.772 9.46737 8.60405 11.3332 6.00032 11.3332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineStartCircle);
export default __webpack_public_path__ + "static/media/line_start_circle.cd97112646ac4ba7134061b6f2a1baa8.svg";
export { ForwardRef as ReactComponent };